import { defineStore } from 'pinia'
import { ref } from 'vue'
import { TBasePurchaseOrderDetail } from '@/core/types'

export const useDetailsStore = defineStore('Details', () => {
  const details = ref<Array<Partial<TBasePurchaseOrderDetail>>>([])

  const setDetails = (payload: Array<Partial<TBasePurchaseOrderDetail>>) => {
    details.value = payload
  }

  return {
    details,
    setDetails,
  }
})
